<template>
  <div class="layout-wrapper wh100">
    <router-view></router-view>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.layout-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .top-wrapper {
    flex-shrink: 0;
  }
  .bottom-wrapper {
    flex: 1;
    height: 0;
  }
}
</style>
